import { render, staticRenderFns } from "./CampaignLanding.vue?vue&type=template&id=0f3f80f4&scoped=true"
import script from "./CampaignLanding.vue?vue&type=script&lang=js"
export * from "./CampaignLanding.vue?vue&type=script&lang=js"
import style0 from "./CampaignLanding.vue?vue&type=style&index=0&id=0f3f80f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3f80f4",
  null
  
)

export default component.exports